import { useEffect } from 'react';
import useEventCallback from './useEventCallback.mjs';
import useReferenceSafeObject from './useReferenceSafeObject.mjs';

function useMutationObserver(element, {
  options: optionsRaw,
  callback: callbackRaw
}) {
  const callback = useEventCallback(callbackRaw);
  const options = useReferenceSafeObject(optionsRaw);
  useEffect(() => {
    if (element !== null) {
      const observer = new MutationObserver(callback);
      observer.observe(element, options);
      return () => {
        observer.disconnect();
      };
    }
  }, [callback, element, options]);
}

export { useMutationObserver as default };
//# sourceMappingURL=useMutationObserver.mjs.map
